import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

const dynamicStyle = {
  4: { width: '6ch', bg: '5.75ch' },
  5: { width: '8.5ch', bg: '7ch' },
  6: { width: '9.5ch', bg: '9ch' },
};

const StyledInput = styled.input`
  border: none;
  font-size: 4ch;
  letter-spacing: 0.5ch;
  width: ${(props) => dynamicStyle[props.theme.maxLength].width};
  background: repeating-linear-gradient(
      90deg,
      dimgrey 0,
      dimgrey 1ch,
      transparent 0,
      transparent 1.5ch
    )
    0 100% / ${(props) => dynamicStyle[props.theme.maxLength].bg} 2px no-repeat;
  &:focus {
    outline: none;
    color: dodgerblue;
  }
`;

const ConfirmCodeInput = (props) => {
  const { maxLength, value, onChange, onPressEnter } = props;

  const onKeyPressHandler = (e) => {
    if (e.charCode === 13 && onPressEnter) onPressEnter(e);
  };
  return (
    <ThemeProvider theme={{ maxLength }}>
      <StyledInput
        maxLength={maxLength}
        autoFocus
        autoComplete="off"
        onChange={onChange}
        value={value}
        onKeyPress={onKeyPressHandler}
      />
    </ThemeProvider>
  );
};

export { ConfirmCodeInput };
